import { render, staticRenderFns } from "./RedeploymentApproval.vue?vue&type=template&id=f12882e2&scoped=true"
import script from "./RedeploymentApproval.vue?vue&type=script&lang=js"
export * from "./RedeploymentApproval.vue?vue&type=script&lang=js"
import style0 from "./RedeploymentApproval.vue?vue&type=style&index=0&id=f12882e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12882e2",
  null
  
)

export default component.exports